module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2023-06-21 at 15.25.09.78e909d7.jpg";